export default function Show({ children, show, as: Component, className, ...otherProps }) {
  if (!show) return null;

  return Component ? (
    <Component className={className} {...otherProps}>
      {children}
    </Component>
  ) : (
    children
  );
}
